export const years = [];
export const months = [];
export const days = [];

for (let i = new Date().getFullYear() - 1; i >= 1900; i--) {
  years.push(i);
}

for (let i = 1; i < 13; i++) {
  if (i <= 9) {
    months.push("0" + i);
  } else {
    months.push(i);
  }
}

for (let i = 1; i < 32; i++) {
  if (i <= 9) {
    days.push("0" + i);
  } else {
    days.push(i);
  }
}
